//
// Module for DROP Exit Calculation Results step content (partial view) displayed within Retirement Benefit Setup wizard
//
rs.module("participant/benefit/setup/retirement/wizard/dropexitcalculationresultsstep",

    ["controls/data/grid", "controls/components/event-banner"],

    function (gridModule, eventBanner) {

        // Initialize the module
        function initialize(
            jsSelectors,
            backendUrls,
            supplementalParams,
            beneficiaryGridProperties,
            singleLifePayOptions,
            certainAndLifePayOptions,
            jointAndSurvivorPayOptions,
            editBeneficiaries,
            primaryBeneficiaryKeys,
            beneficiaryData
        ) {

            // get JS selectors
            var supplementalContentContainer = $.js(jsSelectors.supplementalContentContainer);
            var payOptionSelect = $.js(jsSelectors.payOptionSelect);
            var recalculateSupplementButton = $.js(jsSelectors.recalculateSupplementButton);
            var loadingSpinner = $.js(jsSelectors.loadingSpinner);
            var editBeneficiariesContainer = $.js(jsSelectors.editBeneficiariesContainer);
            var displayBeneficiariesContainer = $.js(jsSelectors.displayBeneficiariesContainer);

            // Hookup factorPlanSelect change event
            payOptionSelect.change(toggleBeneficiaryGrids);

            // recalculateButton click handler
            recalculateSupplementButton.on("click", function (event) {

                loadingSpinner.show();

                // Get selected Supp Pay Option
                var selectedSuppPayOption = payOptionSelect.val();

                // clear any messages in the message banner
                eventBanner.removeAllMessages();

                // Validate pay option selection
                if (!selectedSuppPayOption) {
                    loadingSpinner.hide();
                    eventBanner.addErrorMessages("Please select a supplemental pay option before recalculating.");
                    return;
                }

                // Validate beneficiary selection
                var isSingleLife = singleLifePayOptions
                    .map(String)
                    .indexOf(selectedSuppPayOption) >= 0;

                var isContingentJointAndSurvivor = jointAndSurvivorPayOptions
                    .map(String)
                    .indexOf(selectedSuppPayOption) >= 0;

                var isCertainAndLife = certainAndLifePayOptions
                    .map(String)
                    .indexOf(selectedSuppPayOption) >= 0;

                var selectedBeneficiaries = [];

                if (!isSingleLife) {
                    if (editBeneficiaries) {
                        selectedBeneficiaries = beneficiaryGridProperties.selectedValues || [];
                    } else {
                        selectedBeneficiaries = primaryBeneficiaryKeys || [];
                    }
                }

                if (!isSingleLife && selectedBeneficiaries.length === 0) {
                    loadingSpinner.hide();

                    eventBanner.addErrorMessages("Please select at least one beneficiary before recalculating the supplemental benefit.");

                    return;
                }

                if (!isCertainAndLife && selectedBeneficiaries.length > 1) {
                    loadingSpinner.hide();
                    eventBanner.addErrorMessages(
                        "Only one beneficiary may be selected unless the Supplemental Payment Option has a 'Certain & Life' payment method."
                    );
                    return;
                }

                if (isContingentJointAndSurvivor) {

                    var missingBirthDate = selectedBeneficiaries.some(function (beneficiaryKey) {

                        var beneficiary = beneficiaryData.find(function (b) {
                            return String(b.accountPartyKey) === String(beneficiaryKey);
                        });

                        return !beneficiary || !beneficiary.birthDate;
                    });

                    if (missingBirthDate) {
                        loadingSpinner.hide();
                        eventBanner.addErrorMessages(
                            "The selected beneficiary must have a birth date when the Supplemental Payment Option has a 'Contingent Joint & Survivor' payment method."
                        );
                        return;
                    }
                }

                // Replace step detail content
                $.ajax({
                    url: backendUrls.recalculateSupplement,
                    type: "GET",
                    traditional: true,
                    data: {
                        accountPartyKey: supplementalParams.accountPartyKey,
                        benefitClaimPaymentKey: supplementalParams.benefitClaimPaymentKey,
                        benefitClaimKey: supplementalParams.benefitClaimKey,
                        dropBenefitClaimPaymentKey: supplementalParams.dropBenefitClaimPaymentKey,
                        suppPayOptionKey: selectedSuppPayOption,
                        beneficiaryAccountPartyKeyList: selectedBeneficiaries
                    }
                })
                .done(function (html) {
                    supplementalContentContainer.html(html);
                })
                .always(function () {
                    loadingSpinner.hide();
                });

            });

            function toggleBeneficiaryGrids() {
                var selectedSuppPayOption = payOptionSelect.val();

                var isSingleLife = singleLifePayOptions
                    .map(String)
                    .indexOf(selectedSuppPayOption) >= 0;

                // Only show when NOT single life
                if (!isSingleLife) {
                    if (editBeneficiaries) {
                        editBeneficiariesContainer.show();
                    } else {
                        displayBeneficiariesContainer.show();
                    }
                }
                else {
                    editBeneficiariesContainer.hide();
                    displayBeneficiariesContainer.hide();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);